package data.models

import kotlinx.serialization.Serializable

@Serializable
data class ResetPasswordData(
    val token: String?,
    val code: String?,
    val newPassword: String,
)


